import React, { Fragment } from 'react'
import { Draggable } from '@hello-pangea/dnd'
import classNames from 'classnames'

interface Recipe {
  id: number,
  name: string,
  image_url: string,
}

interface RecipeItemProps extends Recipe {
  isPlaceholder?: boolean,
  isDragging?: boolean,
}

const DraggableRecipe = ({ index, ...recipe }) => {
  const recipeObj = { operation: 'add_batch_recipe', batch_recipe: recipe }

  return (
    <Draggable draggableId={JSON.stringify(recipeObj)} index={index}>
      {(provided, snapshot) => (
        <Fragment>
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`draggable-product ${snapshot.isDragging ? 'dragging' : ''}`}
            data-id={recipe.id}
            ref={provided.innerRef}
          >
            <RecipeItem {...recipe as Recipe}
              isDragging={snapshot.isDragging}
            />
          </div>

          {snapshot.isDragging &&
            <RecipeItem {...recipe as Recipe}
              isPlaceholder={true}
            />
          }
        </Fragment>
      )}
    </Draggable>
  )
}

const RecipeItem: React.FC<RecipeItemProps> = ({
  id, name, image_url, isPlaceholder, isDragging
}) => {
  const productClassNames = classNames(
    'product',
    {
      'dragging': isDragging,
      'placeholder': isPlaceholder,
    }
  )

  return (
    <div className={`${productClassNames}`}>
      <img className='product-image' src={image_url} alt={name} />
      <span className='product-name'>{name}</span>
    </div>
  )
}

export default DraggableRecipe
